import styled, { css } from "styled-components";

export const CardHeaderWrapper = styled.div`
  width: 100%;
  height: 65px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background: #fff7ed;
  border-radius: var(--radiusL);
  padding: var(--spacingS) var(--spacingM);
  margin-bottom: var(--spacingXs);

  > p {
    margin: 0px;
    font-size: var(--textS);
    margin-left: var(--spacingXs);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const IconContainer = styled.div`
  width: 28px;
  height: 22px;
  flex-shrink: 0;

  > svg,
  img {
    width: 100%;
    height: 100%;
    max-width: 28px;
    max-height: 22px;
  }

  ${({ hideIcon }) =>
    hideIcon &&
    css`
      > svg,
      img {
        display: none;
      }
    `}
`;

export default CardHeaderWrapper;
